export default "__VITE_ASSET__CnSLkgv$__"